import update from 'immutability-helper';
import Store from '../../../../interfaces/Store';
import { SlotLine } from '../../../../interfaces/Slot';
import { LineSlotMovement } from '../../../../interfaces/Direction';

export const moveSelectedArticleOnLineSlotReducer = (
  store: Store,
  {
    attachedSlot,
    lineSlotMovements
  }: { attachedSlot: SlotLine; lineSlotMovements: LineSlotMovement[] }
) => {
  return update(store, {
    configuration: {
      slots: {
        $set: [
          ...store.configuration.slots.filter(slot => slot.id !== attachedSlot.id),
          attachedSlot
        ]
      }
    },
    selectedArticle: {
      lineSlotMovements: {
        $set: lineSlotMovements
      }
    }
  });
};
